import { render } from "./NewInventoryItem.vue?vue&type=template&id=344dddee"
import script from "./NewInventoryItem.vue?vue&type=script&lang=js"
export * from "./NewInventoryItem.vue?vue&type=script&lang=js"

import "./NewInventoryItem.vue?vue&type=style&index=0&id=344dddee&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__